SupportDefaultStatusAndNotesPresentation = require('./default_messages')
SupportUtilsHelper = require('../helpers/utils')

class PresenterUtil
  DELIMITER: "$$"
  STATUS: "status"
  NOTES: "notes"

  ###
  it is a strong assumption in the below logic that the keys in the key string would be
  unique. And the same key would not be repeating in the lookup hierarchy.
  ###
  lookup: (source, key_string, attribute) ->
    if attribute? && source? && key_string?
      defaultLookup = SupportDefaultStatusAndNotesPresentation
      lookup_obj = $.extend(true, defaultLookup, source)
      value = lookup_obj[attribute]

      keys = key_string.split PresenterUtil::DELIMITER

      hierarchy = [lookup_obj]
      hierarchy = PresenterUtil::recursiveLookup(keys, hierarchy)

      for obj in hierarchy
        check_value = obj[attribute]
        if check_value?
          value = obj[attribute]

    value

  ###
  Aim to find the deepest possible successful check. If available, pick it up
  ###
  recursiveLookup: (keys, matched_hierarchy) ->
    if !!matched_hierarchy
      best_matched_hierarchy = matched_hierarchy

      if !!keys && keys.length > 0
        lookup_object = matched_hierarchy[matched_hierarchy.length - 1]

        idx = -1
        for key in keys
          idx = idx + 1

          if !!key
            child_object = lookup_object[key]

            if !!child_object
              matched_hierarchySoFar = $.map(matched_hierarchy, (m) -> m)
              matched_hierarchySoFar.push(child_object)

              new_keys = $.map(keys, (k) -> k)
              new_keys.splice(idx, 1)

              further_lookups = PresenterUtil::recursiveLookup(new_keys, matched_hierarchySoFar)

              if further_lookups.length > best_matched_hierarchy.length
                best_matched_hierarchy = further_lookups

      best_matched_hierarchy


  isShipmentAvailable: (order) ->
    voucher = PresenterUtil::getFirstVoucher(order)

    if voucher?
      voucher.shipments? && voucher.shipments.length > 0

  isReturnable: (order) ->
    if order?.isReturnable?
      return evaluate(order.isReturnable)
    else
      return false

  getFirstVoucher: (order) ->
    if order?
      groupons = order.groupons
      if groupons?
        groupons[0]

  isRedeemed: (order) ->
    voucher = PresenterUtil::getFirstVoucher(order)
    if voucher?
      voucher.isMerchantRedeemed || voucher.isCustomerRedeemed

  concatenateLookupKeys: (keys) ->
    (for key in keys
      key.toLowerCase()
    ).join("$$")

  getEditableKey: (is_editable) ->
    if is_editable? && is_editable is true
      'EDITABLE'
    else
      'NOT_EDITABLE'

  getStatusKey: (order) ->
    if order?
      status = order.STATE

      if status is "EXPIRED"
        is_redeemed = PresenterUtil::isRedeemed(order)
        if is_redeemed? && is_redeemed is true
          status = "EXPIRED_REDEEMED"
        else
          status = "EXPIRED_UNREDEEMED"
      status

  getFulfillmentMethodKey: (order)->
    fulfillmentKey = 'fulfilled_enabled'
    fulfillmentMethod = order?.deal?.fulfillmentMethod
    if fulfillmentMethod?.length > 0
      fulfillmentMethod = fulfillmentMethod.toUpperCase()
      if (new RegExp("DROP")).test(fulfillmentMethod) then return "DROPSHIP"
      else
        return _.compact(fulfillmentMethod.split(" ")).join("_")
    fulfillmentKey

  getShipmentStatusKey: (order) ->
    if order?.shipmentDetails
      order.shipmentDetails.SHIPMENT_STATE

  getGiftStatusKey: (order) ->
    if order.isGiftClaimed is true
      "GIFT_CLAIMED"
    else
      "GIFT_UNCLAIMED"

  getGiftDeliveryMethod: (order) ->
    if order.giftInfo
      switch order.giftInfo.giftDeliveryMethod
        when 'email'
          'EGIFT'
        else
          'PRINTED_GIFT'

  getGDTKeys: (order) ->
    keys = ['GDT']
    is_redeemed = PresenterUtil::isRedeemed(order)
    if is_redeemed? && is_redeemed is true
      keys.push('REDEEMED')
    else
      keys.push('UN_REDEEMED')
    keys

  getShipmentKey: (order) ->
    if order?
      if PresenterUtil::isShipmentAvailable(order)
        voucher = PresenterUtil::getFirstVoucher(order)
        if voucher.shipments[0].carrier == "Processing"
          'SHIPMENTS_PROCESSING'
        else
          'SHIPMENTS_AVAILABLE'
      else
        'SHIPMENTS_NOT_AVAILABLE'

  getReturnableKey: (is_returnable) ->
    if !!is_returnable
      if is_returnable is true
        'RETURNABLE'
      else
        'NOT_RETURNABLE'
    else
      'NA'

  getNotReturnableReasonKey: (is_timelimit_exceeded) ->
    if is_timelimit_exceeded? && is_timelimit_exceeded is true
      'TIME_EXECEEDED'
    else
      'NON_RETURNABLE'

  getShippingAddressRequiredKey: (order) ->
    if order? && order.deal? && order.deal.shippingAddressRequired
      'SHIPPING_ADDRESS_REQUIRED'
    else
      'SHIPPING_ADDRESS_NOT_REQUIRED'

  getGetawaysBookingStatus: (order) ->
    if PresenterUtil::getStatusKey(order) is 'REFUNDED'
      'REFUNDED'
    else if PresenterUtil::isBookingNonCancellable(order) and !PresenterUtil::isCheckInDatePassed(order)
      'NON_CANCELLABLE'
    else if PresenterUtil::isCheckInDatePassed(order)
      'EXPIRED'
    else
      PresenterUtil::getStatusKey(order)

  isCheckInDatePassed:(order) ->
    reservationSource = SupportUtilsHelper.getReservationSource(order)
    if reservationSource?.checkInDate? && Date.now() > getMillisecondsOfUTCDateFromISOStringDate(reservationSource.checkInDate)
      return true
    false

  isBookingNonCancellable: (order) ->
    reservationSource = SupportUtilsHelper.getReservationSource(order)
    if reservationSource?.cancellationDeadlineDate? && Date.now > getMillisecondsOfUTCDateFromISOStringDate(reservationSource.cancellationDeadlineDate)
      return true
    false

  getReturnabilityLabelPrintingStatus: (order) ->
    length  = order.goodsReturnInfo?.returns?.length
    if length > 0
      returnStatus = order.goodsReturnInfo?.returns[length - 1].returnStatus
      if returnStatus in ['return_initiated', 'warehouse_received', 'auto_refunded', 'closed']
        return "return_initiated_label_not_printed"
      else if returnStatus in ['label_printed']
        return "return_initiated_label_printed"
      else
        return'NA'
    else
      return 'NA'

module.exports = PresenterUtil
